/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import { Dispatch, FC, SetStateAction, useMemo } from "react";
import VitalsForm from "components/forms/VitalsForm";
import { getNewVitalsDataContent } from "utils/model.utils";
import { FormActionType } from "types";
import { AppointmentInterface } from "medicalsystem-shared";

/**
 * Props for the VitalsDataContent component.
 * @interface NewVitalsDataContentProps
 * @property {Partial<AppointmentInterface>} selectedAppointment - The appointment containing vitals data
 * @property {boolean} [fromProgressNote] - Whether the component is being used from a progress note context
 * @property {Dispatch<SetStateAction<boolean>>} [setSaveVitals] - Callback to trigger vitals saving
 * @property {boolean} [readOnlyForm] - Whether the form should be read-only
 */
interface NewVitalsDataContentProps {
  selectedAppointment: Partial<AppointmentInterface>;
  fromProgressNote?: boolean;
  setSaveVitals?: Dispatch<SetStateAction<boolean>>;
  readOnlyForm?: boolean;
}

/**
 * Content component for displaying vital signs data.
 * Shows existing vitals from an appointment or allows creating new vitals,
 * with optional read-only mode for viewing historical data.
 * @param {NewVitalsDataContentProps} props - Component props
 * @returns {React.ReactElement} The vitals data content component
 */
const VitalsDataContent: FC<NewVitalsDataContentProps> = ({
  selectedAppointment,
  fromProgressNote,
  setSaveVitals,
  readOnlyForm,
}) => {
  const model = useMemo(
    () => (selectedAppointment.vitals ? selectedAppointment.vitals : getNewVitalsDataContent()),
    [selectedAppointment.vitals]
  );

  const type = useMemo(
    () => (selectedAppointment.vitals ? FormActionType.MODIFY : FormActionType.NEW),
    [selectedAppointment.vitals]
  );

  const appointmentId = selectedAppointment ? selectedAppointment.id : null;

  return (
    <VitalsForm
      model={model}
      action={type}
      fromProgressNote={fromProgressNote}
      setSaveVitals={setSaveVitals}
      appointmentId={appointmentId}
      readOnlyForm={readOnlyForm}
      patient={selectedAppointment.patient}
    />
  );
};

export default VitalsDataContent;
